/* ST33LE PDP enhancements.
   1. Title formatter — clean-title treatment on the PDP h1.
      Line 1 comes from the colour phrase Liquid already resolved via
      steele-sibling-color and printed into the colour swatch's sr-only text
      (or the siblings-row label). Reading it back keeps the h1, the colour
      label and every product card in agreement from ONE rule, with no keyword
      list duplicated in JS.
      NOTE: the Color option value is deliberately not used — it is often the
      generic bucket (PACIFIC BLUE -> "BLUE", CHARCOAL -> "CHAR").
      Falls back to the old measurement/first-word split if nothing is found.
   2. Description redistribution — moves Details / Care / Fit+Model sections out
      of the inline description into the theme's collapsible_tab accordions.
   NOTE: all gallery layout code removed — gallery renders per theme settings. */
(function () {
  /* ============ 1. Clean title ============ */
  function cap(word) {
    return word
      .split('/')
      .map(function (part) {
        return part.charAt(0).toUpperCase() + part.slice(1);
      })
      .join('/');
  }

  function textOf(el) {
    if (!el) return '';
    if (el.closest && el.closest('.product-quick-view__product-content')) return '';
    return (el.textContent || '').trim().replace(/\s+/g, ' ');
  }

  function getColorPhrase(h1) {
    var scope =
      (h1.closest &&
        h1.closest(
          '.product__info-wrapper, .product__info-container, section.main-product, .product'
        )) ||
      document;

    /* 1. the product's own colour swatch, rendered by Liquid with the resolved
       phrase. label.swatch-color is the product itself; sibling tiles are <a>. */
    var v = textOf(scope.querySelector('.variant-picker__color label.swatch-color .sr-only'));
    if (v) return v;

    /* 2. size-only products render steele-siblings-row with the phrase in the label. */
    v = textOf(scope.querySelector('.steele-siblings-row .form__label-value'));
    if (v) return v;

    /* 3. generic colour label. */
    v = textOf(scope.querySelector('.product-form__input--color .form__label-value'));
    if (v) return v;

    v = textOf(document.querySelector('.variant-picker__color label.swatch-color .sr-only'));
    return v || '';
  }

  function formatTitle(h1) {
    if (!h1 || h1.querySelector('.steele-clean-title')) return;
    var raw = h1.textContent.trim().replace(/\s+/g, ' ');
    if (!raw) return;
    var skuIndex = raw.search(/\sST-/i);
    if (skuIndex > -1) raw = raw.slice(0, skuIndex).trim();
    var words = raw.toLowerCase().split(' ').map(cap);
    var full = words.join(' ');

    var colorWords, nameWords;

    var phrase = getColorPhrase(h1);
    if (phrase) {
      var cWords = phrase.toLowerCase().split(' ').map(cap);
      var cDisp = cWords.join(' ');
      var idx = full.toLowerCase().indexOf(cDisp.toLowerCase());
      colorWords = cWords;
      if (idx === 0) {
        nameWords = full.slice(cDisp.length).trim().split(/\s+/).filter(Boolean);
      } else if (idx > 0) {
        nameWords = (full.slice(0, idx) + ' ' + full.slice(idx + cDisp.length))
          .trim()
          .split(/\s+/)
          .filter(Boolean);
      } else {
        nameWords = words.slice();
      }
    } else {
      var splitIndex = -1;
      for (var i = 0; i < words.length; i++) {
        if (words[i].indexOf('"') > -1) {
          splitIndex = i;
          break;
        }
      }
      if (splitIndex > 0) {
        colorWords = words.slice(0, splitIndex);
        nameWords = words.slice(splitIndex);
      } else {
        colorWords = words.slice(0, 1);
        nameWords = words.slice(1);
      }
    }

    var wrap = document.createElement('span');
    wrap.className = 'steele-clean-title';
    var colorSpan = document.createElement('span');
    colorSpan.className = 'card__title-color';
    colorSpan.textContent = colorWords.join(' ');
    var nameSpan = document.createElement('span');
    nameSpan.className = 'card__title-name';
    nameSpan.textContent = nameWords.join(' ');
    wrap.appendChild(colorSpan);
    if (nameWords.length) wrap.appendChild(nameSpan);
    h1.innerHTML = '';
    h1.appendChild(wrap);
  }

  /* ============ 2. Description → theme accordions ============ */
  var SECTION_TARGETS = {
    'details': 'details',
    'care instructions': 'care',
    'care': 'care',
    'fit': 'fit',
    'fit note': 'fit',
    'model info': 'fit',
    'size & fit': 'fit',
    'size and fit': 'fit'
  };
  var BOUNDARY = /^(details|care instructions|care|fit|fit note|model info|size & fit|size and fit|style)$/;

  function normText(t) {
    return (t || '').trim().replace(/\s+/g, ' ').replace(/:\s*$/, '').toLowerCase();
  }

  function normHeading(el) {
    var t = (el.textContent || '').trim().replace(/\s+/g, ' ');
    if (!t || t.length > 40) return '';
    return t.replace(/:\s*$/, '').toLowerCase();
  }

  function isHeading(el) {
    if (!el || el.nodeType !== 1) return '';
    var key = normHeading(el);
    if (!key || !BOUNDARY.test(key)) return '';
    var tag = el.tagName;
    if (/^H[1-6]$/.test(tag) || tag === 'STRONG' || tag === 'B') return key;
    if (tag === 'P' || tag === 'DIV' || tag === 'SPAN') {
      var inner = el.querySelector('strong, b');
      if (inner && normHeading(inner) === key) return key;
      if (!el.children.length) return key;
    }
    return '';
  }

  function normalizeBrParagraphs(container) {
    var blocks = Array.prototype.slice.call(container.children);
    blocks.forEach(function (block) {
      if (block.tagName !== 'P' && block.tagName !== 'DIV') return;
      if (!/<br/i.test(block.innerHTML)) return;
      var parts = block.innerHTML.split(/(?:\s*<br\s*\/?\s*>\s*)+/i);
      var hasBoundary = false;
      var probe = document.createElement('div');
      for (var i = 0; i < parts.length; i++) {
        probe.innerHTML = parts[i];
        if (BOUNDARY.test(normText(probe.textContent))) {
          hasBoundary = true;
          break;
        }
      }
      if (!hasBoundary) return;
      var frag = document.createDocumentFragment();
      parts.forEach(function (part) {
        var test = document.createElement('div');
        test.innerHTML = part;
        if (!test.textContent.trim()) return;
        var p = document.createElement('p');
        p.innerHTML = part;
        frag.appendChild(p);
      });
      container.insertBefore(frag, block);
      container.removeChild(block);
    });
  }

  function findAccordionContent(keyword) {
    var accs = document.querySelectorAll('.product__collapsible, .accordion, collapsible-details');
    for (var i = 0; i < accs.length; i++) {
      var acc = accs[i];
      if (acc.closest('.product-quick-view__product-content')) continue;
      var summary = acc.querySelector('summary');
      if (!summary) continue;
      var title = (summary.textContent || '').trim().toLowerCase();
      if (title.indexOf(keyword) === -1) continue;
      var details = acc.tagName === 'DETAILS' ? acc : acc.querySelector('details');
      if (!details) continue;
      var content =
        details.querySelector('.collapsible__content-inner') ||
        details.querySelector('.collapsible__content') ||
        details.querySelector('.accordion__content');
      if (!content) {
        var kids = details.children;
        for (var k = 0; k < kids.length; k++) {
          if (kids[k].tagName !== 'SUMMARY') {
            content = kids[k];
            break;
          }
        }
      }
      if (content) return content;
    }
    return null;
  }

  function redistributeDescription() {
    var containers = document.querySelectorAll('.product__description');
    if (!containers.length) return;

    Array.prototype.forEach.call(containers, function (container) {
      if (!container || container.dataset.steeleRedistributed === '1') return;
      if (container.closest('.product-quick-view__product-content')) return;

      var scope = container.querySelector('[data-show-more-content] .rte') || container;

      normalizeBrParagraphs(scope);

      var children = Array.prototype.slice.call(scope.children);
      if (!children.length) return;

      var sections = [];
      var current = null;

      children.forEach(function (child) {
        var key = isHeading(child);
        if (key) {
          current = {
            key: key,
            target: SECTION_TARGETS[key] || null,
            heading: child,
            nodes: []
          };
          sections.push(current);
        } else if (current) {
          current.nodes.push(child);
        }
      });

      if (!sections.length) return;

      var moved = false;
      sections.forEach(function (section) {
        if (!section.target) return;
        var content = findAccordionContent(section.target);
        if (!content) return;
        section.nodes.forEach(function (n) {
          content.appendChild(n);
        });
        if (section.heading.parentNode) {
          section.heading.parentNode.removeChild(section.heading);
        }
        moved = true;
      });

      if (moved) container.dataset.steeleRedistributed = '1';
    });
  }

  /* ============ boot ============ */
  function run() {
    var candidates = document.querySelectorAll(
      '.product__info-wrapper h1, .product__info-container h1, h1.product__title, .product__title h1, .product__title.h1, section.main-product h1'
    );
    candidates.forEach(formatTitle);

    redistributeDescription();
  }

  function boot() {
    run();
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      redistributeDescription();
      if (tries >= 10) clearInterval(timer);
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
